<template>
  <LayoutDefault>
    Направления деятельности
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'

export default {
  name: 'ActivityEditorView',
  components: {
    LayoutDefault
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
